import React, { useEffect } from 'react';

import { useNavigate } from 'react-router';

import confetti from 'canvas-confetti';

import congratulationImg from '../assets/images/congrats.png';
import cupImg from '../assets/images/cup.png';
import Layout from '../components/common/Layout';

const DocusignCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      confetti({ particleCount: 180, spread: 150 });
    }, 2000);
  }, []);
  return (
    <Layout>
      <div className="approved-page">
        <div className="page-inner">
          <img src={congratulationImg} alt="" className="congratulations" />
          <h2>Congrats on Your New Grant!</h2>
          <h3 className="subtitle">
            You can view all feature loan updates on your account dashboard.
          </h3>
          <button className="primary-btn" onClick={() => navigate('/dashboard')}>
            Go to Dashboard
          </button>
          <img src={cupImg} alt="" className="cup-image" />
        </div>
      </div>
    </Layout>
  );
};

export default DocusignCallback;
